<template>
  <v-card>
    <v-layout wrap px-3 pt-2>
      <v-flex xs4>
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="dateFormatted" label="From Date"
                hint="MM/DD/YYYY format" readonly persistent-hint prepend-icon="event"
                @blur="date = parseDate(dateFormatted)" v-on="on">
              </v-text-field>
            </template>
            <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
          </v-menu>
      </v-flex>
      <v-flex xs4>
        <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="computedDate2Formatted" label="To Date" hint="MM/DD/YYYY format" persistent-hint prepend-icon="event"
              readonly v-on="on" ></v-text-field>
          </template>
          <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs4>
        <v-btn small color="orange darken-2" dark @click="findDonations" >Filter</v-btn>
        <v-btn small color="orange darken-2" dark @click="resetFilter" >Reset</v-btn>
      </v-flex>
    </v-layout>
    <v-card-title>
      Donations
      <v-spacer></v-spacer>
      <v-btn v-if="user.admin == true" small color="red darken-2" dark @click="deleteDonations" >Delete Selected</v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details class="mr-4"></v-text-field>
      <vue-excel-xlsx class="py-1 px-3 rounded_card v-card v-sheet theme--light blue" dark dense style="color: white;"
          :data="selected"
          :columns="xlsHeaders"
          :filename="'donations'"
          :sheetname="'donations'"
          >
          Download
      </vue-excel-xlsx>
    </v-card-title>
    <v-data-table :headers="user.admin== true ? headers : editorHeaders" :items="donations"  class="elevation-1" :pagination.sync="pagination" v-model="selected" select-all item-key="_id" :total-items="amount" :rows-per-page-items="listSize">
      <template slot="headers" slot-scope="props">
        <tr>
          <th v-if="user.admin == true">
            <v-checkbox
              primary
              hide-details
              @click.native="toggleAll"
              :input-value="props.all"
              :indeterminate="props.indeterminate"
            ></v-checkbox>
          </th>
          <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.text=='Action' || header.text=='Subscribe' ? 'text-xs-center' : 'text-xs-left']"
            @click="changeSort(header.value)"
          > 
            {{ header.text }}
            <v-icon>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td v-if="user.admin == true">
            <v-checkbox
              primary
              hide-details
              :input-value="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.username }}</td>
          <td class>{{ props.item.email }}</td>
          <td class>{{ props.item.phone }}</td>
          <td class>{{ props.item.packageOption }}</td>
          <td class><span v-if="props.item.currency">{{props.item.currency}} </span>{{ props.item.amount }}</td>
          <td class>{{ props.item.createdAt | moment("Do MMM YYYY") }}</td>
          <td class v-if="user.admin== true">
            <v-btn icon @click="deleteModal(props.item)">
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </td>
        </tr>  
      </template>
      <v-alert
        v-slot:no-results
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

    <!-- delete dialog -->
    <v-dialog v-model="delete_dialog" max-width="750px">
      <v-toolbar class="red" dark dense>
        <v-toolbar-title>Delete Donation</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="delete_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <h5>Are you sure you want to delete this transaction?</h5>
            </v-flex>

            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteDonation" :loading="loader">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of delete  -->


  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';

export default {
  computed: {
    ...mapGetters(["user"]),
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    computedDate2Formatted () {
      return this.formatDate(this.date2)
    },
  },
  data() {
    return {
      search: "",
      delete_dialog: false,
      listSize: [5,10,25,50,100,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
      dataItem: {},
      loader: false,
      headers: [
        {
          text: "Username",
          align: "left",
          sortable: false,
          value: "username"
        },
        { text: "Email", value: "email" },
        { text: "Phone", value: "phone" },
        { text: "Donation For", value: "packageOption" },
        { text: "Amount", value: "amount" },
        { text: "Date Created", value: "createdAt" },
        { text: "Delete", value: "action" }
      ],
      editorHeaders: [
        {
          text: "Username",
          align: "left",
          sortable: false,
          value: "username"
        },
        { text: "Email", value: "email" },
        { text: "Phone", value: "phone" },
        { text: "Donation For", value: "packageOption" },
        { text: "Amount", value: "amount" },
        { text: "Date Created", value: "createdAt" },
      ],
      xlsHeaders: [
        { label: "Username",field: "username"},
        { label: "Email", field: "email"},
        { label: "Phone", field: "phone"},
        { label: "Donation For", field: "packageOption" },
        { label: "Amount", field: "amount", dataFormat: this.amountFormat},
        { label: "Date Created", field: "createdAt", dataFormat: this.dateFormat }
      ],
      donations: [],
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      date2: new Date().toISOString().substr(0, 10),
      date2Formatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      isFilter: false,
      selected: [],
      pagination: {rowsPerPage: 25,page: 1},
      amount: 0,
    };
  },
  methods: {
    amountFormat(amount) {
      return 'KES '+amount;
    },
    dateFormat(createdAt) {
      return moment(createdAt).format('Do MMM YYYY');
    },
    deleteModal(item) {
      this.dataItem = Object.assign({}, item);
      this.delete_dialog = true;
    },
    deleteDonation() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/transactions/delete/"+data._id})
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    dateFormat(createdAt) {
      return moment(createdAt).format('Do MMM YYYY');
    },
    getDonations() {
      return new Promise((resolve, reject) => {
          let search = this.search.trim().toLowerCase();
          if(search !== '') {
            search = `/`+search;
          }
          const {rowsPerPage, page} = this.pagination;
          let sortBy = '/'+this.pagination.sortBy;
          let order  = -1;
          if(this.pagination.descending == false) {
            order = 1;
          }
          let sortOrder = '/'+order;
          this.$store.dispatch("get", `/transactions/admin/donations`+sortBy+sortOrder+'/'+page+`/`+rowsPerPage+search).then(res => {
            this.donations = res.records;
            const {
                sortBy,
                descending,
                page,
                rowsPerPage
            } = this.pagination;
            this.amount = res.amount;
            resolve();
          });
      });
      /*return new Promise((resolve, reject) => {
          this.$store.dispatch("get", '/transactions/admin/donations').then(res => {
            this.donations = res.records;
            resolve();
          });
      });*/
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    findDonations() {
      return new Promise((resolve, reject) => {
          this.isFilter = true;
          const self = this;
          let search = this.search.trim().toLowerCase();
          const {rowsPerPage, page} = this.pagination;
          let sortBy = this.pagination.sortBy;
          let sortOrder  = -1;
          if(this.pagination.descending == false) {
            sortOrder = 1;
          }
          const data = {
            fromDate: this.date,
            toDate: this.date2,
            page: page,
            keyword: search,
            perpage: rowsPerPage,
            sortBy: sortBy,
            sortOrder: sortOrder
          };
          const res = this.$store
            .dispatch("post", { url: "/transactions/admin/donations/date", data })
            .then(res => {
              self.donations = res.records;
              const {
                    sortBy,
                    descending,
                    page,
                    rowsPerPage
                } = self.pagination;
                self.amount = res.amount;
                resolve();
            });
      });
      /*return new Promise((resolve, reject) => {
          this.isFilter = true;
          const self = this;
          const data = {
            fromDate: this.date,
            toDate: this.date2,
          };
          const res = this.$store
            .dispatch("post", { url: "/transactions/admin/donations/date", data })
            .then(res => {
              self.donations = res.records;
                resolve();
            });
      });*/
    },
    resetFilter() {
      this.isFilter = false;
      this.date = new Date().toISOString().substr(0, 10);
      this.dateFormatted= this.formatDate(new Date().toISOString().substr(0, 10));
      this.menu1 = false;
      this.menu2 = false;
      this.date2 = new Date().toISOString().substr(0, 10);
      this.date2Formatted = this.formatDate(new Date().toISOString().substr(0, 10));
      this.getDonations();
    },
    deleteDonations() {
      const selectedDonations = [];
      this.selected.forEach((value, index) => {
        selectedDonations.push(value._id);
      });
      this.loader = true;
      const data = {
        donations: selectedDonations
      };
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/transactions/admin/delete/donations", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    toggleAll () {
      if (this.selected.length) { 
        this.selected = []
      } else {
        this.selected = this.donations.slice()
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date);
      this.date2Formatted = this.formatDate(this.date2);
    },
    pagination: {
        handler() {
            if(this.isFilter == true){
              this.findDonations();
            } else{
              this.getDonations();
            }
        },
        deep: true
    },
    search() {
        if(this.isFilter == true){
          this.findDonations();
        } else{
          this.pagination.page = 1;
          this.pagination.rowsPerPage = 25;
          this.getDonations();
        }
    }
  },
  /*mounted() {
    this.getDonations();
  }*/
};
</script>